import { render, staticRenderFns } from "./nameTemplates.vue?vue&type=template&id=e124e5be&"
import script from "./nameTemplates.vue?vue&type=script&lang=js&"
export * from "./nameTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports